module.exports = __webpack_public_path__ + "static/img/24.e0628f4.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/qingka1/24.jpg
// module id = irN/
// module chunks = 16